'use client';

import type { ClickButtonAnalyticsProps } from 'lib/analytics/trackClickButton';
import type { ComponentProps } from 'react';
import DownloadButton from '.';
import trackClickButton from 'lib/analytics/trackClickButton';

type DownloadButtonProps = ComponentProps<typeof DownloadButton>;

type TrackedDownloadButtonProps = Omit<DownloadButtonProps, 'onClick'> & {
	analytics: Omit<ClickButtonAnalyticsProps, 'buttonClicked'>;
	onClick?: DownloadButtonProps['onClick'];
};

const TrackedDownloadButton = ({
	analytics,
	onClick,
	...downloadButtonProps
}: TrackedDownloadButtonProps) => {
	return (
		<DownloadButton
			{...downloadButtonProps}
			onClick={(event) => {
				trackClickButton({
					buttonClicked: 'pdf_download',
					...analytics,
				});
				onClick?.(event);
			}}
		/>
	);
};

export default TrackedDownloadButton;
